export interface SpjangItem {
  spjangcd: string;
  spjangnm: string;
  adresa: string;
  adresb: string;
  allpay: string;
  biztype: string;
  halfpay: string;
  item: string;
  prenm: string;
  saupnum: string;
}
